export default __webpack_public_path__ + "1f53fc3b5a0fd5926c8600a17aa26ca5.svg";